import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Personal from "../views/Personal.vue";
import Orderevent from "@/router/orderevent";
import Financial from "@/router/financial";
import Membership from "@/router/membership";
import Search from "@/views/Search.vue"
import sql from "@/views/SQL.vue"

Vue.use(VueRouter);

const routes = [{
    path: "/",
    name: "Home",
    component: Home,
    redirect: '/personal', // 设置默认打开的页面
    children: [{
        path: '/personal', //首页个人中心
        name: 'Personal',
        component: Personal,
      },
      ...Orderevent, ...Financial, ...Membership
    ]
  },
  {
    path: "/login",
    name: "Login",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import( /* webpackChunkName: "Login" */ "../views/Login.vue")
  },
  {
    path: "/search",
    component:Search
  },
  {
    path: "/sql",
    component:sql
  }
];
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;